import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Card } from './ui/card';

const SpotifyCallback = () => {
  const [status, setStatus] = useState('processing');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    handleCallback();
  }, []);

  const handleCallback = async () => {
    try {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');

      if (error) {
        setStatus('error');
        setTimeout(() => {
          window.close();
        }, 2000);
        return;
      }

      if (!code) {
        setStatus('error');
        return;
      }

      // Call backend to exchange code for tokens
      const response = await axios.get(
        `/api/spotify/callback?code=${code}&state=${state}`
      );

      if (response.data.success) {
        setStatus('success');
        // Close the popup window after successful auth
        setTimeout(() => {
          window.close();
        }, 1500);
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Callback error:', error);
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-amber-50 p-4">
      <Card className="glass-card p-8 max-w-md text-center">
        {status === 'processing' && (
          <>
            <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-green-400 to-blue-500 rounded-full flex items-center justify-center animate-pulse">
              <span className="text-3xl">🎵</span>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Connecting to Spotify...
            </h2>
            <p className="text-gray-600 text-sm">
              Please wait while we complete the connection
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-green-400 to-blue-500 rounded-full flex items-center justify-center">
              <span className="text-3xl">✅</span>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Successfully Connected!
            </h2>
            <p className="text-gray-600 text-sm">
              You can now close this window
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-red-400 to-pink-500 rounded-full flex items-center justify-center">
              <span className="text-3xl">❌</span>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Connection Failed
            </h2>
            <p className="text-gray-600 text-sm">
              Please try again or close this window
            </p>
          </>
        )}
      </Card>
    </div>
  );
};

export default SpotifyCallback;
